{{#each (concat pureSubroutines nonPureSubroutines)}}
{{#eachLine content}}
{{.}}
{{/eachLine}}

{{/each}}
